export default "__VITE_ASSET__iv4xyrKI__"